export const phieuNhanHang = {
  sections: {
    list: { title: '收货单' },
    detail: { title: '收货单详情' },
    lines: '收货明细',
    soKhops: '收货对比',
  },
  titles: { add: '创建收货单', addNew: '新增' },
  placeholders: {
    ghiChu: '备注（如包装缺失、损坏）',
  },
  form: {
    codeAuto: '留空自动生成',
    trangThai: '状态',
    sectionHeader: '收货单信息',
    sectionSummary: '收货汇总',
    sectionLines: '收货明细',
    sectionMuaHang: '运输与采购信息',
    sectionLogistics: '物流与装箱',
    tongSoLuongDat: '预计总数',
    tongSoLuongNhan: '实际总数',
    tongThieu: '少收总数',
    tongThua: '多收总数',
    tongTienHang: '商品总额',
    tongSoMatHang: '品项数',
    maSp: '商品编码',
    tenSp: '商品名称',
    lineNote: '备注',
    datHangNcc: '采购单',
    nhaCungCap: '供应商',
    note: '单据备注',
    save: '保存',
    chooseDatHangNcc: '选择采购单',
    openSourcePo: '选择采购单作为来源',
    datHangNccClear: '取消选择采购单',
    datHangNccSearch: '搜索采购单',
    datHangNccEmpty: '暂无采购单。',
    productSearch: '搜索商品',
    lotRequired: '批次号 *',
    startTitle: '开始创建收货单',
    startHint: '选择创建方式 — 系统会尽量预填信息。',
    pathFromPo: '从采购单创建',
    pathFromPoHint: '自动载入供应商与明细，只需调整实收数量。',
    pathIndependent: '独立收货',
    pathIndependentHint: '选择供应商后用 F3 添加商品 — 无采购单时使用。',
    pathRecommended: '推荐',
    backToStart: '重新选择方式',
    receiveAll: '全部收齐',
    receiveAllHint: '将所有行的实收数量设为预计数量',
    lineCount: '{count} 行',
    tuMuaHang: '来自采购',
    tuMuaHangHint: '由采购系统创建 — 不能修改商品行和数量',
    emptyNeedSource: '请先选择收货来源。',
    emptyPickSupplier: '请先选择上方供应商，再用 F3 添加商品。',
    emptyFromPo: '该采购单暂无明细。',
    emptyAddProduct: '暂无商品 — 搜索并添加要收的商品。',
    emptyF3Hint: '按 F3 快速搜索商品。',
  },
  aria: { columnPicker: '选择列' },
  columns: {
    tongSoLuong: '总数量',
    tongTienHang: '商品总额',
    canTraNCC: '应付供应商',
    code: '收货单号',
    chiNhanh: '门店',
    summary: '信息',
    status: '状态',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    maDatHang: '采购单号',
    nhaCungCap: '供应商',
    ngayNhan: '收货日期',
    maPhieuNhapKho: '入库单',
  },
  filter: {
    searchPlaceholder: '按收货单号、采购单号、供应商名称',
    title: '筛选',
    supplier: '供应商',
    datHangNcc: '采购单',
    trangThai: '状态',
    chiNhanh: '门店',
    tuNgay: '开始日期',
    denNgay: '结束日期',
    fromDate: '开始日期',
    toDate: '结束日期',
    dateRangePlaceholder: '选择日期范围',
    maVanChuyenAzl: 'AZL 运单号',
    maYcmh: '采购申请号 (YCMH)',
    sortDir: '排序',
    asc: '升序',
    desc: '降序',
    all: '全部',
    reset: '重置',
    nccTreeAll: '全部供应商',
    nccTreeSearch: '搜索供应商',
    nccTreeEmpty: '暂无供应商',
    chiNhanhTreeAll: '全部门店',
    chiNhanhTreeSearch: '搜索门店',
    chiNhanhTreeEmpty: '暂无门店',
  },
  fields: {
    code: '收货单号',
    chiNhanh: '门店',
    maDatHang: '采购单号',
    supplier: '供应商',
    ngayNhan: '收货日期',
    ngayNhapMua: '采购入库时间',
    status: '状态',
    ghiChu: '备注',
    product: '商品',
    productCode: '商品编码',
    productName: '商品名称',
    donViTinh: '单位',
    tyLeQuyDoi: '换算比例',
    soLuongDat: '预计收货量',
    soLuongNhan: '实际收货量',
    soLuongThieu: '少收',
    soLuongThua: '多收',
    chenhLech: '差异',
    maLo: '批次号',
    hanSuDung: '有效期',
    donGia: '单价',
    thanhTien: '金额',
    lineGhiChu: '行备注',
    actions: '操作',
    nguoiNhan: '收货人',
    createdAt: '创建时间',
    soRef: 'REF 号',
    ngayDatHangThucTe: '实际下单日期',
    ngayPhatHangThucTe: '实际发货日期',
    ngayVeKhoThucTe: '实际到仓日期',
    tenNhanVienMuaHang: '采购员',
    tenNhanVienYeuCau: '申请人员',
    tongTheTich: '总体积 (m³)',
    tongCanNang: '总重量 (kg)',
    hinhThucVc: '运输方式',
    cont: '柜号',
    maVanChuyenNcc: '供应商运单号',
    maVanChuyenAzl: 'AZL 运单号',
    maYcmh: '采购申请 (YCMH)',
    maBaoGia: '报价单号',
    ngayBaoGia: '报价日期',
    donViTinhMua: '采购单位',
    soLuongKhuyenMai: '赠品数量',
    tongSoLuongSanPham: '产品总数',
    soKien: '件数',
    daiThung: '箱长',
    rongThung: '箱宽',
    caoThung: '箱高',
    theTichThung: 'M3/箱',
    canNangThung: 'Kg/箱',
    quyCachThung: '规格/箱',
    canNangSanPham: 'Kg/件',
    theTichSanPham: 'M3/件',
  },
  status: {
    choNhan: '待收货',
    daNhanXong: '已收货',
    daHuy: '已取消',
    khac: '其他',
  },
  filters: {
    hintSection: '收货单筛选',
    hintBody: '按状态、收货日期、供应商或采购单筛选。',
  },
  menu: {
    openSupplierList: '供应商（列表）',
    createfromPhieuNhan: '从收货单创建',
  },
  actions: {
    exportFile: '导出',
    addLine: '添加行',
    complete: '完成收货',
    cancelVoucher: '取消',
    copy: '复制单据',
    dongY: '同意',
    importExcel: '从Excel导入',
    downloadTemplate: '下载模板',
    exportOverview: '导出汇总',
    exportDetail: '导出明细',
    createPhieuNhap: '创建入库单',
    createPhieuNhan: '创建收货单',
  },
  messages: {
    loadError: '无法加载收货单列表。',
    noData: '暂无收货单。',
    listSummary: '总数：{count} 张',
    createSuccess: '已创建收货单。',
    updateSuccess: '已更新收货单。',
    deleteSuccess: '已删除收货单。',
    needLines: '请至少添加一行商品。',
    exportSuccess: '已下载 Excel。',
    importSuccess: '已从 Excel 导入。',
    completeSuccess: '已完成收货单。',
    cancelVoucherSuccess: '已取消收货单。',
    confirmCancelVoucher: '取消单据 {name}？此操作无法撤销。',
    confirmComplete: '完成收货单 {name}？完成后将无法修改明细行。',
    confirmCompleteWarn: '将创建采购入库单（NHAP_MUA）并增加库存。',
    confirmCompleteHint: '请选择入库时间 — 默认取收货单上的收货日期。',
    notFound: '找不到收货单。',
    confirmDelete: '删除收货单 {name}？',
    nhanThuaWarning: '警告：实收数量超过订购数量。',
    needDatHangNcc: '请选择采购单。',
    orSupplier: '或选择供应商独立创建',
    needSource: '请选择采购单或供应商。',
    checkRequiredFields: '请填写必填字段。',
    sourcePoLoaded: '已从采购单 {code} 加载 {count} 项。',
    sourcePoNotFound: '找不到匹配的采购单。',
    noLines: '暂无收货明细。',
    needMaLo: '商品"{code}"启用效期管理 — 请输入批次号。',
    needHanSuDung: '商品"{code}"启用效期管理 — 请输入有效期。',
    needLotCount: '还有 {count} 行缺少批次号/有效期。',
  },
  detailTabs: {
    chung: '总览',
    generalInfo: '信息',
    chiTietHang: '商品明细',
    soKhop: '对比',
    lines: '收货明细',
  },
}
